const listItems = document.querySelectorAll('li.menu-item-has-children > svg');
const goBackBtns = document.querySelectorAll('.Navigation__subMenu__go-back');

const query = window.matchMedia('(max-width: 1024px)');

const initSubMenuFunctionality = () => {
    goBackBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const parentUl = btn.closest('ul');
            parentUl.classList.remove('open');
        });
    });

    const handleSubMenu = (ev) => {
        ev.preventDefault();
        const clickedLink = ev.currentTarget;
        const parent = clickedLink.closest('li');
        const nestedMenu = parent.querySelector('ul');
        nestedMenu.classList.add('open');
    };

    listItems?.forEach((listItem) => listItem.addEventListener('click', handleSubMenu));
};

if (query.matches) {
    initSubMenuFunctionality();
}

const handleMenuMobile = (param) => {
    if (param.matches) {
        initSubMenuFunctionality();
    }
};

query.addEventListener('change', handleMenuMobile);

// Mega menu

const mega_menu = document.querySelectorAll('.mega_menu');
if (mega_menu.length > 0) {
    function updateStyles() {
        const megaMenu__wrapper = document.querySelector('.megaMenu__wrapper');
        const Header = document.querySelector('.Header').offsetWidth;

        mega_menu.forEach((menu) => {
            const wrapperPosition = menu.getBoundingClientRect();
            const differenceFromLeft = wrapperPosition.left;
            const actualInnerWidth = document.body.offsetWidth;

            const child = menu.querySelector('.Navigation__subMenu');
            const width = megaMenu__wrapper.offsetWidth;

            if (window.innerWidth > 1023) {
                const paddingValue = `calc((${actualInnerWidth}px - ${width}px) / 2)`;
                child.style.width = Header + 'px';
                child.style.left = `-${differenceFromLeft}px`;
                child.style.paddingLeft = `${paddingValue}`;
                child.style.paddingRight = `${paddingValue}`;
            } else {
            }
        });
    }

    window.addEventListener('load', updateStyles);
    window.addEventListener('resize', updateStyles);
}
